export default {
  titlePage: 'list Address',
  search: 'search ...',
  id: 'id',
  phone: 'phone',
  country: 'country',
  province: 'province',
  city: 'city',
  title: 'title',
  StudentName: 'student name',
  loading: 'loading ... ',
  operating: 'operating',
  empty: 'list is empty',
  next: 'Next',
  previous: 'Previous',
  success: 'success',

  back : 'back',
  error : 'error',
  save : 'save',
  saving : 'saving ...',
  address:'address',
  details:'details',
  postalCode:'postal code',
  placeholderPhone:'Enter phone',
  placeholderTitle:'Enter title',
  placeholderAddress:'Enter address',
  placeholderDetails:'Enter details',
  placeholderPostalCode:'Enter postal code',
  deleteConfirm: 'Are you sure you want to delete this Address?'
}
